import { render, staticRenderFns } from "./companies-map.vue?vue&type=template&id=23c953cd"
import script from "./companies-map.vue?vue&type=script&lang=js"
export * from "./companies-map.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports